import { Component, Input, OnInit } from '@angular/core';
import { LicenseService } from '../../../../services/license.service';
import { EnvironmentService } from '../../../../services/environment.service';
import { EvaluationBaseTileComponent } from '../tile.component';
import {Observable} from 'rxjs/Observable';

@Component({
    selector: 'itpx-evaluation-scorm-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.css']
})

export class EvaluationScormTileComponent extends EvaluationBaseTileComponent implements OnInit {
    @Input() deliverable: any;

    private images: string;
    private href: string = '#';

    constructor(
        private licenseService: LicenseService,
        private environmentService: EnvironmentService
    ) {
        super();
    }

    ngOnInit() {
        this.images = this.environmentService.config['server'].images;
        super.init(this.licenseService, this.deliverable, true);
    }

    complete(deliverable: any, createTarget: boolean) {
        if(!deliverable.disabled)
          this.href = '/#/evaluation/' + deliverable.type + '/' + deliverable.assignmentId + '/' + deliverable.contents[0].id;
        super.complete(deliverable, createTarget);
    }

    private getDeliverableProgress(): string {
        let report = this.deliverable.report;
        if (!report) {
            return null;
        }

        if (report.completed) {
            return 'completed';
        } else if (report.attempted) {
            return 'in progress';
        } else {
            return 'new';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/content/scorm/tile.component.ts